/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const lnDormitoryRouter = {
	path: '/dormitory',
	component: Layout,
	redirect: 'noRedirect',
	name: '宿舍',
	id: 1500000,
	meta: {
		title: '宿舍',
		icon: 'component',
		roles: [1500000]
	},
	children: [
		{
			path: 'dorm-stay',
			component: () =>
				import(
					/* webpackChunkName: "dorm-stay" */ '@/leniuview/dormitory/dorm-stay'
				),
			name: '入住退宿',
			id: 1500100,
			meta: {
				title: '入住退宿',
				roles: [1500100]
			}
		},
		{
			path: 'dorm-building',
			component: () =>
				import(
					/* webpackChunkName: "dorm-building" */ '@/leniuview/dormitory/dormBuilding'
				),
			name: '宿舍楼',
			id: 1500200,
			meta: {
				title: '宿舍楼',
				roles: [1500200]
			}
		},
		{
			path: 'dorm-utilities',
			component: () =>
				import(
					/* webpackChunkName: "dorm-utilities" */ '@/leniuview/dormitory/dorm-utilities'
				),
			name: '水电费',
			id: 1500300,
			meta: {
				title: '水电费',
				roles: [1500300]
			}
		},
		{
			path: 'personal-bills',
			component: () =>
				import(
					/* webpackChunkName: "dorm-utilities" */ '@/leniuview/dormitory/personal-bills'
				),
			name: '缴费流水单',
			id: 1500300,
			meta: {
				title: '缴费流水单',
				roles: [1500300]
			},
			hidden: true
		},
		{
			path: 'dorm-maintain',
			component: () =>
				import(
					/* webpackChunkName: "dorm-maintain" */ '@/leniuview/dormitory/dorm-maintain'
				),
			name: '宿舍维修',
			id: 1500400,
			meta: {
				title: '宿舍维修',
				roles: [1500400]
			}
		},
		{
			path: 'dorm-hygiene',
			component: () =>
				import(
					/* webpackChunkName: "dorm-hygiene" */ '@/leniuview/dormitory/dorm-hygiene'
				),
			name: '卫生检查',
			id: 1500500,
			meta: {
				title: '卫生检查',
				roles: [1500500]
			}
		}
		// {
		//   path: 'dorm-access',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "dorm-access" */ '@/leniuview/dormitory/dorm-access'
		//     ),
		//   name: '进出记录',
		//   id: 1500600,
		//   meta: {
		//     title: '进出记录',
		//     roles: [1500600],
		//   },
		// },
		// {
		//   path: 'dorm-machine',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "dorm-machine" */ '@/leniuview/dormitory/dorm-machine'
		//     ),
		//   name: '门禁设备',
		//   id: 1500700,
		//   meta: {
		//     title: '门禁设备',
		//     roles: [1500700],
		//   },
		// },
	]
}

export default lnDormitoryRouter
